import Thanks from "./Thanks.Container";

export default Thanks;